import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const ContainerWide = styled(WideContainer)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 1216px;
    }
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const PageWrapper = styled.div`
    width: 100%;
    margin-bottom: -50px;
    overflow: hidden;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    padding: 80px 0;
    border-radius: 64px 64px 0 0;
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-top: 40px;
        padding-bottom: 60px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: -10px;
        z-index: 1;
    }
`;

export const ContentContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-rows: 590px 836px 780px;
    grid-template-columns: repeat(3, minmax(0, auto));
    grid-template-areas:
        'middle-1 . middle-2'
        'small-3 small-4 small-5'
        'small-6 . large-7';
    gap: 40px 32px;
    justify-items: end;
    margin-bottom: 40px;

    & > div:first-child {
        justify-self: start;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-rows: 600px 770px 764px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-rows: repeat(5, auto);
        grid-template-columns: repeat(2, auto);
        grid-template-areas:
            'middle-1 .'
            'middle-2 .'
            'small-3 small-4'
            'small-5 small-6'
            'large-7 .';
        gap: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        flex-direction: column;
    }
`;
